export const localStoreName = "learnableToken";
export const today = `${new Date().getFullYear()}-${
  new Date().getMonth() + 1 > 9 ? "" : "0"
}${new Date().getMonth() + 1}-${new Date().getDate()}`;

export const limitDoB = `${new Date().getFullYear() - 14}-12-31`;
